module.exports = __webpack_public_path__ + "img/spawning_grounds_small.01aeeb7c.png";